import React, { Component } from 'react';
import propTypes from 'prop-types';
import { FormFeedback, Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';

import { makeId } from 'utils/selectors';

import HelpIcon from './HelpIcon';
import styles from './NumericInput.css';

export default class NumericInput extends Component {
  static propTypes = {
    fieldContract: propTypes.shape({
      helpText: propTypes.string,
      name: propTypes.string,
      required: propTypes.bool
    }).isRequired,
    isReadonly: propTypes.bool,
    onChange: propTypes.func.isRequired,
    selectedValue: propTypes.string,
    updateLocation: propTypes.string.isRequired,
    validationMessage: propTypes.string
  };

  static defaultProps = {
    isReadonly: false,
    selectedValue: '',
    validationMessage: undefined
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.incrementDecrementTimeInterval = 15;
    this.incrementInterval = null;
    this.decrementInterval = null;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedValue !== state.selectedValue) {
      return {
        selectedValue: props.selectedValue || '',
        value: props.selectedValue || ''
      };
    }
    return null;
  }

  /**
   * update redux state prop value when number event triggered/ value changed
   */
  handleIncrement = () => {
    const currentValue = Number(this.props.selectedValue);

    // if currentValue is a number, change props value to currentValue
    if (!Number.isNaN(currentValue)) {
      const changedValue = (currentValue + 1).toFixed(2);
      this.props.onChange(changedValue);
    }
  };

  handleDecrement = () => {
    const currentValue = Number(this.props.selectedValue);

    // if currentValue is a number, change props value to currentValue
    if (!Number.isNaN(currentValue)) {
      const changedValue = (currentValue - 1).toFixed(2);
      this.props.onChange(changedValue);
    }
  };

  handleInputChange(e) {
    this.props.onChange(e.target.value);
  }

  startIncrement = () => {
    this.incrementInterval = setInterval(
      this.handleIncrement,
      this.incrementDecrementTimeInterval
    );
  };

  startDecrement = () => {
    this.decrementInterval = setInterval(
      this.handleDecrement,
      this.incrementDecrementTimeInterval
    );
  };

  endIncrement = () => {
    clearInterval(this.incrementInterval);
  };

  endDecrement = () => {
    clearInterval(this.decrementInterval);
  };

  render() {
    const {
      fieldContract: { helpText, name, required },
      isReadonly,
      updateLocation,
      validationMessage
    } = this.props;
    const { value } = this.state;

    return (
      <div className="d-flex flex-column my-3">
        <span className="d-flex align-items-center font-weight-bold mb-2">
          {`${name}${required ? '*' : ''}`}
          {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
        </span>
        <InputGroup className="w-100">
          <Input
            invalid={validationMessage}
            className={styles.noSpinners}
            type="number"
            disabled={isReadonly}
            value={value}
            onChange={this.handleInputChange}
            data-test-id={makeId({ updateLocation })}
          />
          <InputGroupAddon className="rounded-right" addonType="append">
            <Button
              disabled={isReadonly}
              data-test-id={makeId({ updateLocation, operator: 'decrement' })}
              onMouseDown={this.startDecrement}
              onMouseUp={this.endDecrement}
              title="Decrement (-1)"
              outline
            >
              -
            </Button>
            <Button
              disabled={isReadonly}
              data-test-id={makeId({ updateLocation, operator: 'increment' })}
              onMouseDown={this.startIncrement}
              onMouseUp={this.endIncrement}
              title="Increment (+1)"
              outline
            >
              +
            </Button>
          </InputGroupAddon>
          <FormFeedback>{validationMessage}</FormFeedback>
        </InputGroup>
      </div>
    );
  }
}
